import FishHoghooghiIcon from '@/components/common/icons/FishHoghooghi'
import LocationDocumentIcon from '@/components/common/icons/LocationDocument'
import MojavezFaaliyatIcon from '@/components/common/icons/MojavezFaaliyat'
import UseriDocumentIcon from '@/components/common/icons/UseriDocument'
import { ReactElement } from 'react'

interface IMerchantDocumentProps {
  id: number
  title: string
  subtitle?: string
  icon: ReactElement
}

const realMerchantDocuments: IMerchantDocumentProps[] = [
  {
    id: 1,
    title: 'تصویر جواز کسب یا اینماد',
    icon: <MojavezFaaliyatIcon width={160} height={160} className="z-[2]" />
  },
  {
    id: 2,
    title: 'تصاویر شناسنامه و کارت ملی',
    icon: <UseriDocumentIcon width={160} height={160} className="z-[2]" />
  },
  {
    id: 3,
    title: 'معرفی‌نامه',
    icon: <LocationDocumentIcon width={160} height={160} className="z-[2]" />
  }
]
const legalMerchantDocuments: IMerchantDocumentProps[] = [
  {
    id: 1,
    title: 'تصویر آگهی تاسیس شرکت',
    icon: <MojavezFaaliyatIcon width={160} height={160} className="z-[2]" />
  },
  {
    id: 2,
    title: 'تصاویر شناسنامه و کارت ملی',
    icon: <UseriDocumentIcon width={160} height={160} className="z-[2]" />
  },
  {
    id: 3,
    title: 'تصویر اساسنامه',
    icon: <FishHoghooghiIcon width={160} height={160} className="z-[2]" />
  },
  {
    id: 4,
    title: 'معرفی‌نامه',
    icon: <LocationDocumentIcon width={160} height={160} className="z-[2]" />
  }
]
export {
  realMerchantDocuments,
  legalMerchantDocuments,
  type IMerchantDocumentProps
}
